export const downloadBlobFile = (url: string, fileName: string) => {
  if (!url) return;
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName ?? "File");
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const getExtension = (name: string): string => {
  return name.split(".").pop().toLowerCase();
};

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export function downloadContent(
  content: string,
  fileName = "text.txt",
  contentType = "text/plain",
) {
  const a = document.createElement("a");
  const file = new Blob([base64ToArrayBuffer(content)], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}

// для accept FileField
export const fileTypes = {
  doc: ".doc,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword",
  xls: ".xlsx,.xls,application/excel,application/vnd.msexcel,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: ".csv,text/csv,application/csv,text/comma-separated-values",
  pdf: ".pdf,application/pdf",
  image: "image/*",
};
export const checkFileTypes = (key: string, value: string) => {
  if (key && value) {
    return key.split(",").includes(value);
  }
  return true;
};

export const saveAsFile = (
  fileName,
  data = "",
  postfix = crypto.randomUUID(),
) => {
  if (typeof document === "undefined")
    throw "Предназначено для работы в браузере!";

  const lnk = document.createElement("a");
  lnk.href = `data:text/plain;content-disposition=attachment;filename=${fileName},${data}`;
  lnk.download = fileName;
  lnk.target = "_blank";
  lnk.style.display = "none";
  lnk.id = `downloadlnk-${postfix}`;
  document.body.appendChild(lnk);
  lnk.click();
  document.body.removeChild(lnk);
};
